import { type FC } from 'react';
import cn from 'classnames';

import {
  type AdditionalLotteryReward,
  type LotteryAdditionalRewardName,
  type LotteryTicketType,
  type TicketRewardType,
} from '@/common/types/lottery';
import { StringSmall } from '@/components/Typography/Typography';
import { Picture } from '@/components/ui/Picture/Picture';
import { TicketIcon } from '@/components/ui/TicketIcon/TicketIcon';

import { ticketRewardToTier } from '../../config';

import tgemPng from '/img/tgem.png';
import tgemWebp from '/img/tgem.webp';

interface AdditionalRewardItemProps {
  type: LotteryTicketType;
  amount: string;
  reward: AdditionalLotteryReward;
  isActive?: boolean;
}

const AdditionalRewardItem: FC<AdditionalRewardItemProps> = ({
  type,
  amount,
  reward,
  isActive,
}) => {
  const rewardName = Object.keys(reward)[0] as LotteryAdditionalRewardName;
  const isTicket = ['silverTicket', 'goldTicket', 'diamondTicket'].includes(
    rewardName,
  );

  return (
    <div
      className={cn(
        'flex items-center justify-between py-1 px-2 border-b border-white/20',
        isActive && 'bg-white/10',
      )}
    >
      <div className="flex items-center gap-2">
        <TicketIcon type={type} className="size-[16px] shrink-0" />
        <StringSmall className="!text-white/60 capitalize">{type}</StringSmall>
      </div>
      <div className="w-[80px]">
        <StringSmall weight="bold">{amount}</StringSmall>
      </div>
      <div className="flex items-center gap-2 w-[64px]">
        {rewardName === 'tgem' && (
          <Picture
            className="size-[24px] shrink-0"
            img={tgemPng}
            webp={tgemWebp}
            alt="tgem"
          />
        )}
        {isTicket && (
          <TicketIcon
            type={ticketRewardToTier[rewardName as TicketRewardType]}
            className="size-[24px] shrink-0"
          />
        )}
        <StringSmall weight="bold">{reward[rewardName]}</StringSmall>
      </div>
    </div>
  );
};

export { AdditionalRewardItem };
